import { ConfigService } from './config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BuscadorTP } from '../models/buscadorTP';
import { TransferenciaPlantaCabecera } from '../models/transferenciaPlantaCabecera';
import { TokenService } from '../utils/token.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TPService {

  private tpServerUri: string;
  private apiUrl = environment.apiUrl;

  constructor(
    private httpCliente: HttpClient,
    private configService: ConfigService,
    private tokenService: TokenService
  ) {
    this.tpServerUri = this.apiUrl + '/' + this.configService.TPURI;
  }

  private getHeaders() {
    const authToken = this.tokenService.getAuthToken();
    const authTokenBearer = this.tokenService.getAuthTokenBearer();

    return new HttpHeaders({
      'Authorization': `Bearer ${authTokenBearer}`,      
      'PortalO2G' : `${authToken}`
    });
  }

  aprobarTransferenciaPlanta(tpc: TransferenciaPlantaCabecera) {
    return this.httpCliente.post(this.tpServerUri + 'AprobarTransferenciaPlanta', tpc, { headers: this.getHeaders() });
  }

  rechazarTransferenciaPlanta(tpc: TransferenciaPlantaCabecera) {
    return this.httpCliente.post(this.tpServerUri + 'RechazarTransferenciaPlanta', tpc, { headers: this.getHeaders() });
  }
  cTransferenciasPlanta(buscador: BuscadorTP) {
    return this.httpCliente.post(this.tpServerUri + 'CTransferenciasPlanta', buscador, { headers: this.getHeaders() });
  }
  cTransferenciaPlanta(idPais: string, idCompania: string, idSalesOrg: string, idTipoOrden: string, codigo: number) {
    return this.httpCliente.get(this.tpServerUri + 'CTransferenciaPlanta?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idTipoOrden=" + idTipoOrden + "&codigo=" + codigo, { headers: this.getHeaders() });
  }
  amTransferenciaPlanta(tpc: TransferenciaPlantaCabecera) {
    return this.httpCliente.post(this.tpServerUri + 'AMTransferenciaPlanta', tpc, { headers: this.getHeaders() });
  }
  aTransferenciaPlantaItem(tpc: TransferenciaPlantaCabecera) {
    return this.httpCliente.post(this.tpServerUri + 'ATransferenciaPlantaItem', tpc, { headers: this.getHeaders() });
  }
  mTransferenciaPlantaItem(tpc: TransferenciaPlantaCabecera) {
    return this.httpCliente.post(this.tpServerUri + 'MTransferenciaPlantaItem', tpc, { headers: this.getHeaders() });
  }
  bTransferenciaPlantaItem(codigoCabecera: number, codigoItem: number) {
    return this.httpCliente.get(this.tpServerUri + 'BTransferenciaPlantaItem?codigoCabecera=' + codigoCabecera + "&codigoItem=" + codigoItem, { headers: this.getHeaders() });
  }
  cListasPreciosAutocompleteSearch(idPais: string, idCompania: string, idSalesOrg: string, nroCliente: string, idFormaPago: string, idGrupoCliente: string, idTipoOrden: string, search: string) {
    return this.httpCliente.get(this.tpServerUri + 'CListasPreciosAutocompleteSearch?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroCLiente=" + nroCliente + "&idFormaPago=" + idFormaPago + "&idGrupoCliente=" + idGrupoCliente + "&idTipoOrden=" + idTipoOrden + "&search=" + search, { headers: this.getHeaders() });
  }
  cListaPrecioItemsAutocompleteSearch(idPais: string, idCompania: string, idSalesOrg: string, idTipoListaPrecios: string, idTerminoPago: string, idMoneda: string, idPlanta: string, idUbicacionAlmacenamiento: string, search: string) {
    idMoneda = typeof idMoneda == 'undefined' || idMoneda == null ? "" : idMoneda
    idTerminoPago = typeof idTerminoPago == 'undefined' || idTerminoPago == null ? "" : idTerminoPago
    idTipoListaPrecios = typeof idTipoListaPrecios == 'undefined' || idTipoListaPrecios == null ? "" : idTipoListaPrecios
    return this.httpCliente.get(this.tpServerUri + 'CListaPrecioItemsAutocompleteSearch?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idTipoListaPrecios=" + idTipoListaPrecios + "&idTerminoPago=" + idTerminoPago + "&idMoneda=" + idMoneda + "&idPlanta=" + idPlanta + "&idUbicacionAlmacenamiento=" + idUbicacionAlmacenamiento + "&search=" + search, { headers: this.getHeaders() });

  }
  cTerminosPagoTipoListaPrecios(idPais: string, idCompania: string, idSalesOrg: string, idTipoListaPrecios: string) {
    return this.httpCliente.get(this.tpServerUri + 'CTerminosPagoTipoListaPrecios?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idTipoListaPrecios=" + idTipoListaPrecios, { headers: this.getHeaders() });
  }
  cStoragesLocationsPlanta(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.tpServerUri + 'CStoragesLocationsPlanta?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }
  cDireccionesDistribuidorCliente(idPais: string, idCompania: string, idSalesOrg: string, nroCliente: string, nroClienteDistribuidor: string) {
    return this.httpCliente.get(this.tpServerUri + 'CDireccionesDistribuidorCliente?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroCliente=" + nroCliente + "&nroClienteDistribuidor=" + nroClienteDistribuidor, { headers: this.getHeaders() });
  }
  cListaPreciosDivisionCabecera(idPais: string, idCompania: string, idSalesOrg: string, idComprobante: string, idDivision: string) {
    return this.httpCliente.get(this.tpServerUri + 'CListaPreciosDivisionCabecera?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idComprobante=" + idComprobante + "&idDivision=" + idDivision, { headers: this.getHeaders() })
  }
  cTransferenciaPlantaItem(codigoItem: number) {
    return this.httpCliente.get(this.tpServerUri + 'CTransferenciaPlantaItem?codigoItem=' + codigoItem, { headers: this.getHeaders() });
  }
  cTransferenciasLotes(idPais: string, idCompania: string, idSalesOrg: string, idProducto: string, idSucursal) {
    return this.httpCliente.get(this.tpServerUri + 'CTransferenciasLotes?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idProducto=" + idProducto + "&nroClienteDireccion=" + idSucursal, { headers: this.getHeaders() });
  }
}
